<template>
  <div
    class="main_container"
    v-loading.fullscreen.lock="loadingpage"
    style="font-size: 14px"
  >
    <van-nav-bar title="站点排名" :fixed="true" />

    <!--     <div v-show="loadingpage" class="ui active dimmer">
      <div class="ui loader"></div>
    </div>-->

      <!--选择时间 -->
      <van-popup v-model="showTime" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          :type="dateType"
          title="选择完整时间"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="showTime = false"
          @confirm="confirmPicker"
          @change="dateChange"
          :filter="filterTime"
        />
      </van-popup>
    <div class="body">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="refresh"
        style="width: 100%;overflow: auto"
      >
        <div class="head">
          <div class="nav">
            更新于： {{ update_time }}
            <span
              v-show="data_type != 'wind_direction'"
              style="margin-left: 10px"
              >均值： {{ avg_val }}{{ getUnit(data_type) }}</span
            >
            <span
              v-show="data_type == 'wind_direction'"
              style="margin-left: 10px"
              >均值： {{ pm_avg | calc_direction }}</span
            >
          </div>
          <div style="margin: 0">
            <div class="select">
              <div class="screen_menus" :class="!page_config.showHistory ? 'screen_menus_current' : ''">
                <van-row gutter="20" v-if="region">
                  <van-col span="8" style="border-right: 1px solid #e5e5e5">
                    <div
                      class="screen_menu"
                      @click="showRegionSelect = !showRegionSelect"
                    >
                      <span class="screen_menu_text">{{ region.label }}</span>
                      <van-icon
                        name="arrow"
                        style="font-size: 12px"
                        :class="{
                          active_icon: showRegionSelect
                        }"
                      />
                    </div>
                  </van-col>

                  <van-col span="8" style="border-right: 1px solid #e5e5e5">
                    <div
                      class="screen_menu"
                      @click="showTimeSelect = !showTimeSelect"
                    >
                      {{ timep.label }}
                      <van-icon
                        name="arrow"
                        style="font-size: 12px"
                        :class="{
                          active_icon: showTimeSelect
                        }"
                      />
                    </div>
                  </van-col>

                  <van-col span="8" style="border-right: 1px solid #e5e5e5">
                    <div
                      class="screen_menu"
                      @click="showTypeSelect = !showTypeSelect"
                    >
                      {{ type_name }}
                      <van-icon
                        name="arrow"
                        style="font-size: 12px"
                        :class="{
                          active_icon: showTypeSelect
                        }"
                      />
                    </div>
                  </van-col>
                </van-row>
              <van-row class="time-sel" v-if="page_config.showHistory">
               <div style="text-align: left; padding-left: 18px">
                <span :class="timeLabel == '历史' ? 'lable' : ''"
                  >{{ timeLabel }}：
                </span>
                <span style="position: relative">
                  <van-icon name="calendar-o" class="calendar" />
                  <input
                    :class="timeLabel == '历史' ? 'baseipt lable' : 'baseipt'"
                    type="text"
                    v-model="update_time"
                    :disabled="timep.value === 'min'"
                    @click="showPopTime"
                    @focus="hideVk"
                     style="position: relative; width: 144px"
                  />
                </span>
                <span style="padding-left: 7px">
                  <span v-show="data_type != 'wind_direction'"
                    >均值： {{ avg_val }}{{ getUnit(data_type) }}</span
                  >
                  <span v-show="data_type == 'wind_direction'"
                    >均值： {{ avg_val | calc_direction }}</span
                  >
                </span>
                <van-icon
                  style="padding-left: 5px"
                  color="#018bff"
                  name="replay"
                  v-show="timeLabel == '历史'"
                  @click="resetTime"
                />
              </div>
            </van-row>
              </div>

              <transition name="showlist">
                <van-radio-group
                  class="popup"
                  id="pop1"
                  v-show="showRegionSelect"
                >
                  <van-cell
                    class="select-cell"
                    :class="{
                      cellActive: item.value == region.value
                    }"
                    v-for="item in option_region"
                    :key="item.value"
                    clickable
                    :value="item.label"
                    @click="(region = item), (showRegionSelect = false)"
                  ></van-cell>
                </van-radio-group>
              </transition>

              <transition name="showlist">
                <van-radio-group
                  class="popup"
                  id="pop2"
                  v-show="showTimeSelect"
                >
                  <van-cell
                    class="select-cell"
                    :class="{
                      cellActive: item.value == timep.value
                    }"
                    v-for="item in option_time"
                    :key="item.label"
                    clickable
                    :name="item.value"
                    :value="item.label"
                    @click="(timep = item), (showTimeSelect = false)"
                  ></van-cell>
                </van-radio-group>
              </transition>

              <transition name="showlist">
                <van-radio-group
                  class="popup"
                  id="pop3"
                  v-show="showTypeSelect"
                >
                  <van-cell
                    class="select-cell"
                    :class="{
                      cellActive: type.value == data_type
                    }"
                    v-for="type in option_data_type"
                    :key="type.label"
                    clickable
                    :value="type.label"
                    @click="
                      (data_type = type.value),
                        (type_name = type.label),
                        (showTypeSelect = false)
                    "
                  ></van-cell>
                </van-radio-group>
              </transition>
            </div>
          </div>
        </div>
        <div style="padding: 5px 0 0 0;">
          <table
            class="ui unstackable table"
            style="text-align: center;margin-top: 45px"
          >
            <thead>
              <tr style="width: 100%">
                <th style="width: 6%">#</th>
                <!-- <th style="width: 95px" v-show="region.value==727">
                区县
                <i @click="reverse=false  " v-show="rankType == 'name2' && reverse==true" class="iconfont icon-xiaosanjiaodown"></i>
                <i @click="reverse=true " v-show="rankType == 'name2' && reverse==false" class="iconfont icon-xiaosanjiaoup"></i>
                <i @click="rankType= 'name2', reverse=!reverse" v-show="rankType != 'name2'" class="iconfont icon-yousanjiao"></i>
                </th>-->

                <th style="width: 29%">
                  乡镇
                  <i
                    @click="reverse = false"
                    v-show="rankType == 'name3' && reverse == true"
                    class="iconfont icon-xiaosanjiaodown"
                  ></i>
                  <i
                    @click="reverse = true"
                    v-show="rankType == 'name3' && reverse == false"
                    class="iconfont icon-xiaosanjiaoup"
                  ></i>
                  <i
                    @click="rankType = 'name3'"
                    v-show="rankType != 'name3'"
                    class="iconfont icon-yousanjiao"
                  ></i>
                </th>

                <th style="width: 40%">
                  监测站
                  <i
                    @click="reverse = false"
                    v-show="rankType == 'name4' && reverse == true"
                    class="iconfont icon-xiaosanjiaodown"
                  ></i>
                  <i
                    @click="reverse = true"
                    v-show="rankType == 'name4' && reverse == false"
                    class="iconfont icon-xiaosanjiaoup"
                  ></i>
                  <i
                    @click="rankType = 'name4'"
                    v-show="rankType != 'name4'"
                    class="iconfont icon-yousanjiao"
                  ></i>
                </th>

                <th class="data_cel" style="width: 25%">
                  {{ data_type_info.label }}
                  <i
                    @click="reverse = false"
                    v-show="rankType == data_type_info.value && reverse == true"
                    class="iconfont icon-xiaosanjiaodown"
                  ></i>
                  <i
                    @click="reverse = true"
                    v-show="
                      rankType == data_type_info.value && reverse == false
                    "
                    class="iconfont icon-xiaosanjiaoup"
                  ></i>
                  <i
                    @click="rankType = data_type_info.value"
                    v-show="rankType != data_type_info.value"
                    class="iconfont icon-yousanjiao"
                  ></i>
                </th>
              </tr>
            </thead>
            <tbody v-if="stations_filtered_page.length > 0">
              <!-- <van-list v-model="listloading" :finished="finished" @load="onLoad"> -->
              <tr
                v-for="(station, idx) in stations_filtered_page"
                @click="clickRow(station)"
                :key="idx"
              >
                <td style="width: 10%">{{ idx + 1 }}</td>
                <!-- <td v-show="region.value==727" style="width: 70px">{{station.path.name2}}</td> -->
                <td style="width: 20%">
                  {{ station.path.name3 | str_slice(6) }}
                </td>
                <td style="width: 40%">
                  {{ station.path.name4 | str_slice(9) }}
                </td>
                <td style="width: 30%" v-if="isSensor(data_type)">
                  <div
                    class="color_cell"
                    :style="{
                      background: intensity(data_type).bgcolor.getColor(
                        station.sensor[data_type]
                      ),
                      color: intensity(data_type).fgcolor.getColor(
                        station.sensor[data_type]
                      )
                    }"
                  >
                    {{ filterSensorValue(data_type, station) }}
                  </div>
                </td>
                <td v-else>
                  {{ $sensortypeRound(data_type, station.sensor[data_type]) }}
                </td>
              </tr>
              <!-- </van-list> -->
            </tbody>
          </table>
          <van-empty
            v-if="
              !stations_filtered_page || stations_filtered_page.length === 0
            "
            description="无数据"
            style="padding: 0; width: 100%"
          />
          <!-- <stationList :stations_filtered="stations_filtered" :rankType="rankType" :data_type="data_type" :reverse="reverse"></stationList> -->
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { option_time, waterTypes } from "../../option/option.js";
import { mapState, mapGetters } from "vuex";
var _ = require("lodash");
// import stationList from '../../components/stationList'
export default {
  data() {
    return {
      page_config: _page_config,
      showRegionSelect: false,
      showTimeSelect: false,
      showTypeSelect: false,
      type_name: "PM₁₀",
      option_time,
      rankType: "pm10",
      reverse: true,
      timep: option_time[0],
      data_type: "pm10",
      region: {},
      page: 1,
      touchStart: "",
      distance: "",
      flag: "",
      loading: "",
      loadingpage: false,
      isLoading: false,
      update_time: "",
      avg_val: 0,
      listloading: false,
      finished: false,
      interval: null,
           // 时间组件
      minDate: new Date(2018, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      showTime: false,
      timeLabel: "更新至",
      dateType: "date",
      mondays: []
    };
  },
  filters: {
    fil(v) {
      return Math.round(v * 100) / 100;
    },
    calc_direction(v) {
      if (v) {
        let descs = ["北", "东北", "东", "东南", "南", "西南", "西", "西北"];
        let index = Math.floor((v + 22.5) / 45) % 8;
        return descs[index];
      } else {
        return "";
      }
    },
    str_slice(v, n) {
      if (v.length > n) {
        return v.substr(0, n) + "...";
      } else {
        return v;
      }
    }
  },
  computed: {
    ...mapState([
      "stations",
      "pm_avg",
      "userInfo",
      "group_info",
      "option_region",
      "rankStatus"
    ]),
    ...mapGetters(["option_data_type"]),
    data_type_info() {
      const tyeps = this.option_data_type.map(item => item.value);
      if (tyeps.includes(this.data_type)) {
        return this.option_data_type.find(x => {
          return x.value === this.data_type;
        });
      } else {
        return this.option_data_type[0];
      }
    },
    group_info_with_all() {
      var group_info = this.group_info;
      if (group_info[0].id3 != 0) {
        group_info.unshift({ name3: "全部", id3: 0 });
      }
      return group_info;
    },
    scHeight: function() {
      return "" + document.documentElement.clientHeight - 138;
    },
    stations_filtered_page() {
      this.loadingpage = false;
      return this.stations_filtered // .slice(0, 50 * this.page);
    },
    stations_filtered: function() {
      if (!this.stations || this.stations.length === 0 || !this.region) {
        return [];
      }
      var stations_filtered = [];
      if (this.region.value === 0) {
        stations_filtered = this.stations;
        const timesArr = this.stations
          .filter(item => item.sensor && item.sensor.TIME)
          .map(item => item.sensor.TIME)
          .sort((a, b) => Date.parse(a) - Date.parse(b));
        this.update_time = timesArr[timesArr.length - 1] || "--";
        if (moment(this.update_time).isValid()) {
          this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
        }
        if (this.reverse) {
          stations_filtered = stations_filtered.sort(this.desc);
        } else {
          stations_filtered = stations_filtered.sort(this.asc);
        }
        return stations_filtered;
      }
      var self = this;
      var stations = this.stations;
      if (!stations && stations.length === 0) {
        return;
      }
      var t_need = true;
      for (var i in stations) {
        // stations_filtered.push(stations[i])
        if (
          stations[i].path.id3 == this.region.value ||
          stations[i].path.id2 == this.region.value ||
          stations[i].path.id1 == this.region.value
        ) {
          stations_filtered.push(stations[i]);
        }
        var t = this.stations[i].sensor.TIME;
        if (t && t_need == true) {
           if (this.timep.value == "hour") {
            this.update_time = moment(t).format("yyyy-MM-DD HH")
          } else if (this.timep.value == "min") {
            this.update_time = moment(t).format("yyyy-MM-DD HH:mm")
          } else if(this.timep.value == "day"){
            this.update_time = moment(t).format("yyyy-MM-DD")
          } else if(this.timep.value == "week"){
            this.update_time = moment(t).format("yyyy-MM-DD");
          }else if(this.timep.value == "month"){
            this.update_time = moment(t).format("yyyy-MM");
          }else if(this.timep.value == "year"){
            this.update_time = moment(t).format("yyyy");
          }
          if (moment(this.update_time).isValid()) {
            this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
          }
          t_need = false;
        }
      }
      if (
        this.rankType == "name2" ||
        this.rankType == "name3" ||
        this.rankType == "name4"
      ) {
        if (this.reverse) {
          stations_filtered = _.sortBy(stations_filtered, [
            function(o) {
              return o.path[self.rankType];
            }
          ]);
        } else {
          stations_filtered = _.sortBy(stations_filtered, [
            function(o) {
              return o.path[self.rankType];
            }
          ]).reverse();
        }
      } else {
        if (this.reverse) {
          stations_filtered = stations_filtered.sort(this.desc);
        } else {
          stations_filtered = stations_filtered.sort(this.asc);
        }
      }
      return stations_filtered;
    },
    colorRange() {
      if (!G_SENSOR_DATA_TYPE_INFO) {
        return;
      }
      let colorRange = [];
      G_SENSOR_DATA_TYPE_INFO.forEach(item => {
        if (item.value === this.data_type) {
          colorRange[0] = item["color_range_min"];
          colorRange[1] = item["color_range_max"];
        }
      });
      return colorRange;
    }
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.saveRankStatus()
    if (this.interval) {
      clearInterval(this.interval);
    }
    next();
  },
  mounted() {
    // 默认值
    const {timeType} = this.rankStatus;
    if(timeType) {
      this.timep = timeType;
    }
    this.initRankData();
    // this.getAvg();
    window.addEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    option_data_type: {
      handler() {
        if (!this.option_data_type.length) {
          return
        }
        const {dataType} = this.rankStatus;
        if(dataType) {
          const cur_info = this.option_data_type.find(item => item.value === dataType);
          if (cur_info) {
            this.data_type = cur_info.value
            this.type_name = cur_info.label;
          } else {
            this.data_type = this.option_data_type[0].value;
            this.type_name = this.option_data_type[0].label;
          }
        } else {
          this.data_type = this.option_data_type[0].value;
          this.type_name = this.option_data_type[0].label;
        }
      },
      immediate: true
    },
    option_region: {
      handler() {
        const {region} = this.rankStatus;
        if(region) {
          this.region = region;
        } else {
          this.region = this.option_region[0];
        }

      },
      immediate: true
    },
    userInfo() {
      this.initRankData()
    },
    timep() {
       this.currentDate = new Date()
       this.resetTime()
       if (this.timep.value == "hour") {
        this.dateType = "datehour";
        this.update_time = moment(this.update_time).format("yyyy-MM-DD HH");
      } else if (this.timep.value == "min") {
        this.dateType = "date";
        this.timeLabel = "更新至";
        this.update_time = moment(this.update_time).format("yyyy-MM-DD HH:mm");
      } else if(this.timep.value == "day"){
        this.dateType = "date";
        this.update_time = moment(this.currentDate).format("yyyy-MM-DD");
      }else if(this.timep.value == "week"){
        this.dateType = "date";
        this.update_time = moment(this.currentDate).format("yyyy-MM-DD");
      }else if(this.timep.value == "month"){
        this.dateType = "year-month";
        this.update_time = moment(this.currentDate).format("yyyy-MM");
      }else if(this.timep.value == "year"){
        this.dateType = "year-month";
        this.update_time = moment(this.currentDate).format("yyyy");
      }
      if (moment(this.update_time).isValid()) {
        this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
      }
      this.initRankData()
    },
    stations_filtered() {
      this.getAvg();
    },
    showRegionSelect() {
      if (this.showRegionSelect == true) {
        this.stopBodyScroll(true);
        this.showTimeSelect = false;
        this.showTypeSelect = false;
      }
      if (
        !this.showRegionSelect &&
        !this.showTimeSelect &&
        !this.showTypeSelect
      ) {
        this.stopBodyScroll(false);
      }
    },
    showTimeSelect() {
      if (this.showTimeSelect == true) {
        this.stopBodyScroll(true);
        this.showRegionSelect = false;
        this.showTypeSelect = false;
      }
      if (
        !this.showRegionSelect &&
        !this.showTimeSelect &&
        !this.showTypeSelect
      ) {
        this.stopBodyScroll(false);
      }
    },
    showTypeSelect() {
      if (this.showTypeSelect) {
        this.stopBodyScroll(true);
        this.showRegionSelect = false;
        this.showTimeSelect = false;
      }
      if (
        !this.showRegionSelect &&
        !this.showTimeSelect &&
        !this.showTypeSelect
      ) {
        this.stopBodyScroll(false);
      }
    },
    data_type() {
      this.rankType = this.data_type;
      this.getAvg();
    },
    $route(to, from) {
      if (to.name == "home") {
        var len = window.history.length;
        this.$router.go(-len);
      }
    }
  },
  methods: {
     dateChange(d) {
      if (this.timep.value !== "week") return false
      let values = d.getValues()
      let monthSt = moment(`${values[0]}-${values[1]}`)
      let monthEnd = moment(`${values[0]}-${values[1]}`).add(1, 'months')
      console.log(monthSt, monthEnd)
      let mondays = []
      while (monthSt < monthEnd){
        if (monthSt.day() === 1){
          mondays.push(monthSt.format('DD'))
        }
        monthSt.add(1, 'days')
      }
      this.mondays = mondays
    },
     hideVk(e) {
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },
    filterTime(type, options){
      if (this.timep.value == "week") {
        if(type ==='day'){
          return this.mondays
        }
      } else if (this.timep.value == "year") {
        if(type ==='month'){
          return options.filter(option => option %32===0)
        }
      }
      return options
    },
     showPopTime() {
      this.showTime = true;
    },
    // 确认选择的时间
    confirmPicker(val) {
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      let second = val.getSeconds();

      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      if (second >= 0 && second <= 9) {
        second = `0${second}`;
      }

      this.className = "timeClass";
      this.update_time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      if (this.timep.value == "hour") {
        this.update_time = `${year}-${month}-${day} ${hour}:${minute}`;
      } else if (this.timep.value == "day") {
        this.update_time = `${year}-${month}-${day}`;
      } else if(this.timep.value == "week"){
        this.update_time = `${year}-${month}-${day}`;
      }else if(this.timep.value == "month"){
        this.update_time = `${year}-${month}`;
      }else if(this.timep.value == "year"){
        this.update_time = `${year}`;
      }
      if (moment(this.update_time).isValid()) {
        this.update_time = moment(this.update_time).format("YYYY-MM-DD HH:mm:00");
      }
      this.timeLabel = "历史";
      this.showTime = false;
      this.$store.dispatch("getUserStations", {
        groups: this.userInfo.devGroupIds,
        timep: this.timep.value,
        timepoint: this.timep.value === "min" ? "" : moment(this.update_time).format("yyyy-MM-DD HH:mm:SS") ,
      });
    },
    resetTime() {
      this.timeLabel = "更新至";
      this.currentDate = new Date();
      this.refresh();
    },
    saveRankStatus() {
      const timeType = this.timep;
      const dataType = this.data_type;
      const region = this.region;
      this.$store.commit("updateRankStatus", {timeType, dataType, region})
    },
    addInterval() {
      this.interval && clearInterval(this.interval);
      if (this.timep.value === "min") {
        this.interval = setInterval(() => {
          this.$store.dispatch("getUserStations", {
            groups: this.userInfo.devGroupIds,
            timep: "min"
          });
        }, 30000);
      } else {
        return;
      }
    },
    filterSensorValue(v, station) {
      return this.$sensortypeRound(v, station.sensor[v]);
    },
    getUnit(data_type) {
      let unit = "";
      for (let item of this.option_data_type) {
        if (item.value === this.data_type) {
          unit = item.unit;
        }
      }
      return unit;
    },
    getAvg() {
      var sum_val = 0;
      var len_val = 0;
      for (var i in this.stations_filtered) {
        var v = this.stations_filtered[i].sensor[this.data_type];
        if (v) {
          sum_val += v;
          len_val += 1;
        }
      }
      console.log(sum_val);
      if (len_val > 0) {
        if (this.data_type == "cod" || this.data_type == "temperature") {
          this.avg_val = Math.round((sum_val / len_val) * 10) / 10;
        } else if (
          this.data_type == "ammonia_nitrogen" ||
          this.data_type == "ph"
        ) {
          this.avg_val = Math.round((sum_val / len_val) * 100) / 100;
        } else {
          this.avg_val = Math.round(sum_val / len_val);
        }
      } else {
        this.avg_val = "--";
      }
    },
    intensity(data_type) {
      return new colorIntensity.getIntensity({
        dataType: data_type,
        max: this.colorRange[1],
        min: this.colorRange[0],
        colorType: "static"
      });
    },
    isSensor(type) {
      if (
        type === "wendu" ||
        type === "shidu" ||
        type === "wind_speed" ||
        type === "wind_direction"
      ) {
        return false;
      }
      return true;
    },
    handleScroll() {
      console.log('scroll')
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
        console.log(scrollTop - (this.page - 1) * 1450)
      if (scrollTop - (this.page - 1) * 1450 > 1200) {
        this.page += 1;
      }
    },
    stopBodyScroll(isFixed) {
      let bodyEl = document.body;
      let top = 0;
      if (isFixed) {
        top = window.scrollY;

        bodyEl.style.position = "fixed";
        bodyEl.style.top = -top + "px";
      } else {
        bodyEl.style.position = "";
        bodyEl.style.top = "";

        window.scrollTo(0, top); // 回到原先的top
      }
    },
    initRankData() {
      this.loadingpage = true;
      if(this.userInfo) {
        this.$store
        .dispatch("getUserStations", {
          groups: this.userInfo.devGroupIds,
          timep: this.timep.value
        })
        .then(function() {
          self.loadingpage = false;
        }).catch(e=>{
          self.loadingpage = false;
        });
      }
      this.addInterval();
    },
    refresh() {
      var self = this;
      this.$store
        .dispatch("getUserStations", {
          groups: this.userInfo.devGroupIds,
          timep: this.timep.value
        })
        .then(() => {
          self.isLoading = false;
          // setTimeout(() => {
          //   self.isLoading = false;
          // }, 300);
        });
    },
    reverseList() {
      this.reverse = !this.reverse;
    },
    clickRow(row) {
      // if (this.userInfo.Fullfunc == 1){
         var endTimePar = ''
       if (this.timep.value == 'hour'){
        endTimePar = new Date(this.update_time+':00:00').getTime()
      }else {
        endTimePar = new Date(this.update_time).getTime()
      }
      var params = {
        sn: row.path.DevSN,
        lng: row.path.Lng,
        lat: row.path.Lat,
        data_type: this.data_type,
        timep: this.timep.value,
        endTimePar: endTimePar
      };
      this.$router.push({ name: "detailData", params });
      // }
    },
    asc(x, y) {
      var x_val = x.sensor[this.data_type];
      var y_val = y.sensor[this.data_type];
      if (!x_val) {
        x_val = 10000;
      }
      if (!y_val) {
        y_val = 10000;
      }
      return x_val - y_val;
    },
    desc(x, y) {
      var x_val = x.sensor[this.data_type];
      var y_val = y.sensor[this.data_type];
      if (!x_val) {
        x_val = -10000;
      }
      if (!y_val) {
        y_val = -10000;
      }
      return y_val - x_val;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head {
  position: fixed;
  width: 100%;
  background: white;
  height: 51px;
}
.screen_menu {
  display: flex;
  justify-content: center;
  align-items: center;
}
.screen_menu_text {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
}
.select {
  margin: 2px auto 0 auto;
  width: 100%;
  background: white;
}
.data_th {
  min-width: 55px;
}
.color_cell {
  margin: 0 auto;
  text-align: center;
  padding: 0 5px;
  width: 60px;
  border-radius: 5px;
}
/* .data_cel {
  padding-left: 15px;
} */

.vue-pull-refresh {
  height: 100%;
  overflow-y: auto;
  transition: 330ms;
  -webkit-overflow-scrolling: touch;
}
.vue-pull-refresh-msg {
  margin-top: -50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  color: #666;
  border-bottom: 1px solid #eee;
}
.vue-pull-refresh-msg .icon-reverse {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}
.vue-pull-refresh-loading {
  -webkit-animation: loadRotate 1s linear infinite;
  animation: loadRotate 1s linear infinite;
}
@-webkit-keyframes loadRotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes loadRotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.time-sel {
  background: rgb(250, 250, 252);
  padding-top: 4px;
}
.lable {
  color: rgb(90, 161, 221);
}
.baseipt {
  height: 18px;
  border: 1px solid rgb(229, 229, 229);
}
.calendar {
  position: absolute;
  right: 2px;
  top: 1px;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/pages/application/rank.vue